import React from 'react';
import { mediaData } from '../data/mediaData';
import { motion } from "framer-motion";

import { storyChangeAnim } from "../data/common";
import config from '../data/config';

const AllStoriesWrapper = ({ setShowAllStoriesScreen, currStoryId, callGaHandler, categoryListData, storyChangeHandler, pauseSlideOnTap }) => {
  const closeAllStories = () => {
    setShowAllStoriesScreen(() => false);
    pauseSlideOnTap(false, 'play');
    callGaHandler('View_all_stories', 'Back');
  }

  const changeStory = (category, index) => {
    callGaHandler('View_all_stories_story_click', category?.category_name);
    storyChangeHandler(index + 1);
    setShowAllStoriesScreen(() => false);
  }

  return (
    <motion.div
      key={currStoryId}
      className="main-swiper-wrapper main-swiper-wrapper-splash splash-wrapper-last"
      variants={storyChangeAnim}
      initial="initial"
      animate="active"
      exit="exit"
    >
      <div className="feedback-img-block one3d-stories-block">
        <div className="one3d-stories-block-header">
          <button className="back-story-button" onClick={closeAllStories}>
            <img src={mediaData["backStory"]} alt="back-icon" />
          </button>
          <span>All Stories</span>
        </div>
        <div className="one3d-stories-block-bottom">
          <ul>
            {categoryListData?.map((category, index) => category?.chapters?.length > 0 ? (
              <li key={category?.category_id} onClick={() => changeStory(category, index)}>
                <button className="inner-block">
                  <div className="col-top">
                    <img 
                      src={`${config.BUCKET_URL}${category?.large_thumbnail_relative_path}`}
                      alt={category?.category_name}
                    />
                  </div>
                  <div className="col-bottom">
                    <b>{category?.category_name}</b>
                    <div className="all-tag">
                      {category?.chapters[0]?.chapter_hash_tags?.map((hastag, idx) => <span key={idx}>{hastag}</span>)}
                    </div>
                  </div>
                </button>
              </li>
            ) : null)}
          </ul>
        </div>
      </div>
    </motion.div>
  );
}

export default AllStoriesWrapper